import { createRouter, createWebHistory } from 'vue-router'
import { watch } from 'vue'
import Home from '@/views/Home.vue'
import { site, i18n } from '@/i18n'

const router = createRouter({
  history: createWebHistory('/'),
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0, behavior: 'smooth' }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: '保护伞 II — 多角色聚合支付与 C2C 担保交易 SaaS 平台' }
    },
    {
      path: '/product',
      name: 'Product',
      component: () => import('@/views/Product.vue'),
      meta: { title: '产品功能 — 保护伞 II' }
    },
    {
      path: '/matching',
      name: 'Matching',
      component: () => import('@/views/Matching.vue'),
      meta: { title: '通道撮合市场 — 保护伞 II' }
    },
    {
      path: '/c2c',
      name: 'C2c',
      component: () => import('@/views/C2c.vue'),
      meta: { title: 'C2C 担保交易 — 保护伞 II' }
    },
    {
      path: '/security',
      name: 'Security',
      component: () => import('@/views/Security.vue'),
      meta: { title: '安全中心 — 保护伞 II' }
    },
    {
      path: '/roles',
      name: 'Roles',
      component: () => import('@/views/Roles.vue'),
      meta: { title: '角色与解决方案 — 保护伞 II' }
    },
    {
      path: '/developers',
      name: 'Developers',
      component: () => import('@/views/Developers.vue'),
      meta: { title: '开发者中心 — 保护伞 II' }
    },
    {
      path: '/help',
      name: 'Help',
      component: () => import('@/views/Help.vue'),
      meta: { title: '帮助中心 — 保护伞 II' }
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import('@/views/Download.vue'),
      meta: { title: '下载中心 — 保护伞 II' }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { title: '登录 — 保护伞 II', hideFooter: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
})

router.afterEach(() => {
  applyTitle()
})

function applyTitle() {
  const name = router.currentRoute.value.name as string | undefined
  const t = name ? (site.seo.titles as Record<string, string>)[name] : undefined
  if (t) document.title = t
}

// 语言切换时同步刷新标题 (导航不触发 afterEach 时的兜底)
watch(() => i18n.lang, () => applyTitle())

export default router

